import { useTranslation } from 'react-i18next';

import { Box } from '@/shared/ui';
import { SvgIcon } from '@/shared/ui/SvgIcon';

import { ChannelCard } from '../ChannelCard/ChannelCard';

interface ITelegramPersonalSelectAuthMethodProps {
  onSelectQr: () => void;
  onSelectPhone: () => void;
}

export const TelegramPersonalSelectAuthMethod = ({
  onSelectQr,
  onSelectPhone,
}: ITelegramPersonalSelectAuthMethodProps) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: 'grid',
        gap: '10px',
      }}
    >
      <ChannelCard
        variant="secondary"
        icon={<SvgIcon name="telegram" fontSize="inherit" />}
        label={t('channels:tgPersonal.authorizationMethod.qr.title')}
        caption={t('channels:tgPersonal.authorizationMethod.qr.caption')}
        onClick={onSelectQr}
      />
      <ChannelCard
        variant="secondary"
        icon={<SvgIcon name="telegram" fontSize="inherit" />}
        label={t('channels:tgPersonal.authorizationMethod.phone.title')}
        caption={t('channels:tgPersonal.authorizationMethod.phone.caption')}
        onClick={onSelectPhone}
      />
    </Box>
  );
};
